import { SET_DIALOG, SET_ACTIVE_VIEW } from '../actions/navigation'

const defaultState = {
    activeView: 'overview',
    dialog: '',
    modalProps: {}
}

export default (state = defaultState, action) => {
    switch (action.type) {
        case SET_DIALOG:
            return {
                ...state,
                dialog: action.dialog,
                modalProps: action.modalProps
            }
        case SET_ACTIVE_VIEW:
            return {
                ...state,
                activeView: action.activeView
            }
        default:
            return state
    }
}
